module.exports = {
  localeName: 'zh-CN',
};
